// extracted by mini-css-extract-plugin
export var activeTitleStyling = "FaqSection-module--activeTitleStyling--bf27a";
export var headingContainerStyling = "FaqSection-module--headingContainerStyling--9052d";
export var questionsContainer = "FaqSection-module--questionsContainer--bb771";
export var sectionContent = "FaqSection-module--sectionContent--59e18";
export var titleStyling = "FaqSection-module--titleStyling--c69ab";